import { render, staticRenderFns } from "./SalonesMoodle.vue?vue&type=template&id=6241be1a&"
import script from "./SalonesMoodle.vue?vue&type=script&lang=js&"
export * from "./SalonesMoodle.vue?vue&type=script&lang=js&"
import style0 from "./SalonesMoodle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports